
<div mat-dialog-content>
    <div class="confirm-message">
        <span class="msg-title"><i class="Appkit4-icon icon-logout-fill"></i> Confirm </span> <br>
        Are you sure you want to sync the Fx Rates?
    </div>
  
</div>
<div mat-dialog-actions>
    <div class="a-modal-footer modal-footer pad-zero" style="float: right; display: flex; justify-content: flex-end; width: 100%;">
        <ap-button [label]="'Cancel'" class="ap-mr-spacing-3" [disabled]="!enableButton" [btnType]="'primary'"
            (onClick)="cancel()"></ap-button>
        <ap-button [btnType]="'primary'" [label]="'Yes'" class="ap-mr-spacing-3" [disabled]="!enableButton"
        (onClick)="syncfxRates()">@if (!enableButton) {
<i class="fa fa-spin fa-spinner" ></i>
}</ap-button>

    </div>
  
</div>